import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy rounded-t-[32px] mt-24 mx-6">
      <div className="max-w-7xl mx-auto px-12 lg:px-20 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* CTA Section */}
          <div className="lg:col-span-1">
            <h3 className="font-serif text-3xl lg:text-4xl font-bold text-white mb-8 lg:mb-12">
              İletişime Geçin
            </h3>
            <Link
              to="/iletisim"
              className="inline-flex items-center justify-center bg-gold text-navy font-sans font-semibold px-8 py-3 rounded-full hover:bg-gold-light transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              İletişime Geç
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-sans text-lg font-medium text-white mb-6">Keşfet</h4>
            <nav className="flex flex-col space-y-3">
              <Link to="/" className="font-sans text-base text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
                Ana Sayfa
              </Link>
              <Link to="/hakkinda" className="font-sans text-base text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
                Hakkında
              </Link>
              <Link to="/galeri" className="font-sans text-base text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
                Galeri
              </Link>
              <Link to="/blog" className="font-sans text-base text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
                Blog
              </Link>
              <Link to="/iletisim" className="font-sans text-base text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
                İletişim
              </Link>
            </nav>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="font-sans text-lg font-medium text-white mb-6">Takip Edin</h4>
            <div className="flex flex-col space-y-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center font-sans text-base text-gray-400 hover:text-gold transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl mr-3"></i>
                Instagram
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center font-sans text-base text-gray-400 hover:text-gold transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-line text-xl mr-3"></i>
                LinkedIn
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center font-sans text-base text-gray-400 hover:text-gold transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl mr-3"></i>
                Twitter
              </a>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <p className="font-sans text-base text-white mb-5">
              Yeni içeriklerden haberdar olun
            </p>
            <form className="flex items-center" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 bg-white/10 border border-gray-600 text-white placeholder-gray-400 px-4 py-3 rounded-l-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm"
              />
              <button
                type="submit"
                className="bg-white text-navy w-12 h-12 flex items-center justify-center rounded-r-lg hover:bg-gold transition-colors duration-300 cursor-pointer"
                aria-label="Abone Ol"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Decorative Brand Name */}
        <div className="relative mt-16 overflow-hidden">
          <div className="text-navy-light/40 font-serif font-bold text-4xl lg:text-6xl tracking-wider opacity-40">
            FATIH SINAN YILMAZ
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-700 text-center">
          <p className="font-sans text-sm text-gray-500">
            © {currentYear} Fatih Sinan Yılmaz. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
